import { useTranslation } from 'react-i18next';

function Solutions() {
  const { t } = useTranslation();
  const solutions = t('solutions.items', { returnObjects: true });

  return (
    <section id="solutions" className="section solutions-section">
      <div className="solutions-layout">
        <div>
          <div className="eyebrow">{t('solutions.eyebrow')}</div>
          <h2>{t('solutions.title')}</h2>
          <p>{t('solutions.description')}</p>
        </div>

        <div className="solutions-cloud" aria-label={t('solutions.aria')}>
          {solutions.map((solution) => (
            <span key={solution}>{solution}</span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Solutions;
